import { createClient } from "@supabase/supabase-js";

const url = (import.meta.env.VITE_SUPABASE_URL as string) || "";
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || "";

if (!url || !anonKey) {
  const msg =
    "[supabase] VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY mancanti. " +
    "Configurale nelle Environment Variables del progetto Vercel.";
  console.error(msg);
  // Sentry capture (init lazy in main.tsx se VITE_SENTRY_DSN è settato).
  if (import.meta.env.VITE_SENTRY_DSN) {
    void import("@sentry/react")
      .then((Sentry) => Sentry.captureException(new Error(msg)))
      .catch(() => {});
  }
}

// Fallback placeholder così createClient non crasha l'intero bundle quando
// le env vars non sono ancora state configurate su Vercel. Le chiamate auth
// falliranno graziosamente con errore visibile nei form, invece di bloccare
// l'app al mount.
export const supabase = createClient(
  url || "https://placeholder.supabase.co",
  anonKey || "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

export { DASHBOARD_URL, SITE_URL } from "./site-config";
